var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBenefitMembership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_02"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 423",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8867_97260)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.558 41.3574H63.4144C64.4332 41.359 65.4097 41.7624 66.1301 42.4793C66.8504 43.1961 67.2558 44.1679 67.2574 45.1817V65.4544C67.2478 66.4623 66.8387 67.4257 66.119 68.1351C65.3993 68.8444 64.4274 69.2423 63.4144 69.2423H26.5986C25.5863 69.2423 24.6149 68.8442 23.8962 68.1347C23.1775 67.4252 22.7698 66.4618 22.7617 65.4544V45.1817C22.7617 44.1685 23.1658 43.1967 23.8851 42.4797C24.6045 41.7626 25.5804 41.359 26.5986 41.3574H34.6073",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.7617 48.2666H67.2391",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.833 58.4619H62.2497",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7617 53.6904H67.2391",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.833 63.2695H53.6247",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M46.1058 24.6489L48.5419 29.6004C48.6271 29.7883 48.7591 29.9515 48.9253 30.0745C49.0916 30.1975 49.2866 30.2763 49.492 30.3034L54.9733 31.0974C55.2037 31.1253 55.4213 31.2182 55.6004 31.365C55.7796 31.5119 55.9128 31.7066 55.9845 31.9263C56.0562 32.146 56.0633 32.3815 56.005 32.6051C55.9466 32.8286 55.8254 33.031 55.6554 33.1883L51.6845 37.0428C51.5407 37.1809 51.4333 37.3521 51.3717 37.5413C51.3101 37.7305 51.2962 37.9319 51.3313 38.1277L52.2692 43.5822C52.3074 43.8066 52.2814 44.0372 52.1941 44.2475C52.1068 44.4579 51.9618 44.6395 51.7756 44.7717C51.5894 44.9039 51.3696 44.9812 51.1413 44.9948C50.913 45.0085 50.6855 44.9579 50.4847 44.8489L45.5759 42.2792C45.3989 42.1847 45.2012 42.1353 45.0004 42.1353C44.7996 42.1353 44.6019 42.1847 44.4249 42.2792L39.5161 44.8489C39.3132 44.9619 39.0821 45.0149 38.85 45.0014C38.6179 44.988 38.3945 44.9087 38.2062 44.7729C38.0179 44.6372 37.8726 44.4507 37.7874 44.2354C37.7022 44.0201 37.6808 43.785 37.7255 43.558L38.6635 38.1034C38.6985 37.9076 38.6846 37.7063 38.623 37.5171C38.5614 37.3279 38.454 37.1567 38.3102 37.0186L34.3333 33.164C34.1631 33.0063 34.0419 32.8035 33.9839 32.5795C33.9258 32.3554 33.9335 32.1196 34.0058 31.8997C34.0782 31.6798 34.2123 31.4852 34.3922 31.3387C34.5722 31.1922 34.7905 31.1001 35.0215 31.0731L40.5027 30.2792C40.7017 30.2522 40.891 30.1766 41.0535 30.0593C41.2161 29.9419 41.347 29.7863 41.4345 29.6064L43.8707 24.6549C43.9645 24.4378 44.1201 24.2527 44.3184 24.1225C44.5166 23.9923 44.7487 23.9225 44.9862 23.9219C45.2237 23.9212 45.4563 23.9897 45.6552 24.1189C45.8541 24.248 46.0107 24.4323 46.1058 24.6489V24.6489Z",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8867_97260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 50,
    fill: "white",
    transform: "translate(22 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitMembership);
export default __webpack_public_path__ + "static/media/icon__benefit-membership.81f9eb54ca3f5a35824a32fadf66d1a3.svg";
export { ForwardRef as ReactComponent };